// ─────────────────────────────────────────────────────────────────────────────
// The typed API client.
//
// `AppRouter` is imported as a TYPE ONLY, so the browser bundle contains no
// server code — but every procedure name, input shape and return type is known
// to the compiler. Renaming a field on the server breaks the build here rather
// than producing `undefined` at runtime in front of a user.
//
// There is no `as any` anywhere in this file, and none is needed.
// ─────────────────────────────────────────────────────────────────────────────

import { createTRPCReact, type inferReactQueryProcedureOptions } from "@trpc/react-query";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "@server/api-types";

export const trpc = createTRPCReact<AppRouter>();

export type ReactQueryOptions = inferReactQueryProcedureOptions<AppRouter>;
export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>;

/** The structured error the server attaches to every failure. */
export interface ApiError {
  readonly kind: string;
  readonly code: string;
  readonly message: string;
  readonly messageAr?: string;
}

/** Extracts the bilingual message from a tRPC error, with a safe fallback. */
export function apiError(error: unknown): ApiError {
  const fallback: ApiError = { kind: "internal", code: "unknown", message: "Something went wrong. Please try again." };
  if (typeof error !== "object" || error === null) return fallback;

  const data = (error as { data?: { appError?: unknown } }).data;
  const appError = data?.appError;
  if (typeof appError === "object" && appError !== null) {
    const e = appError as Record<string, unknown>;
    if (typeof e["code"] === "string" && typeof e["message"] === "string") {
      return {
        kind: typeof e["kind"] === "string" ? e["kind"] : "internal",
        code: e["code"],
        message: e["message"],
        ...(typeof e["messageAr"] === "string" ? { messageAr: e["messageAr"] } : {}),
      };
    }
  }

  const message = (error as { message?: unknown }).message;
  return typeof message === "string" ? { ...fallback, message } : fallback;
}
